import { useEffect, useState, useContext } from "react";
import Api from "../components/Api";
import Layout from "../components/Layout";
import TrackerFilter from "../components/TrackerFilter";
import TrackerTotalItems from "../components/TrackerTotalItems";
import DateFilter from "../components/DateFilter";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import { useSearchParams } from "react-router-dom";
import { convertToArabicNumbers } from '../utils/numberUtils';
import { formatNumber } from '../utils/numberUtils'
import GlobalState from "../contexts/GlobalState";
import { Helmet } from "react-helmet";


export default function Tracker() {

    ChartJS.register(ArcElement, Tooltip, Legend, Title);

    const [generalDataApiOptions, setGeneralDataApiOptions] = useState({});
    const [trackerDataApiOptions, setTrackerDataApiOptions] = useState({});
    const [tracker_settings, setTrackerSettings] = useState();
    const [tracker_data, setTrackerData] = useState();

    const [searchParams, setSearchParams] = useSearchParams();

    const [category_filters, setCategoryFilters] = useState();
    const [date_filter, setDateFilter] = useState();
    const [date_filter_range, setDateRangeFilter] = useState();

    const [selected_date, setSelectedDate] = useState("");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedFilters, setSelectedFilters] = useState({
        source: [],
        donor: [],
        aidType: [],
        subAid: [],
        recipient: [],
        beneficiary: [],
        year: []
    });

    const has_active_filters = selected_date || startDate || endDate || date_filter || date_filter_range || Object.values(category_filters || {}).some((arr) => arr && arr.length > 0) || Object.values(selectedFilters || {}).some((arr) => arr && arr.length > 0);

    const [current_page, setCurrentPage] = useState(1);
    const [last_page, setLastPage] = useState();

    const locale = localStorage.getItem('language');

    const [download,setDownload] =useState(0);
    const [loading,setLoading] = useState(false);
    // const [disable_download,setDisableDownload] = useState(false);

    const { generalDataGlobal } = useContext(GlobalState);


    const clearAllFilters = () => {
        setCategoryFilters({});
        setSelectedFilters({}); 
        setDateFilter("");
        setDateRangeFilter(null);
        setSelectedDate(""); 
        setStartDate(null);
        setEndDate(null);
        setSearchParams({}); 
        setCurrentPage(1); 
    };
    

    useEffect(() => {
        setGeneralDataApiOptions({
            url: "tracker-settings",
            callback: (res) => {
                setTrackerSettings(res.data);
            },
        }); 
    }, []); 

    const handleFilterChange = (filters) => {
      setCategoryFilters(filters);
      setCurrentPage(1); 
    };
  
    const handleDateFilterChange = (time) => {
      setDateFilter(time);
      setDateRangeFilter()
      setCurrentPage(1); 
    };

    const handleDateRangeFilterChange = (time) => {
        setDateRangeFilter(time);
        setDateFilter()
        setCurrentPage(1); 
    };


// Update temporary state when filters change
// const handleFilterChange = (filters) => {
//     setPendingFilters((prev) => ({ ...prev, category: filters }));
// };

// const handleDateFilterChange = (time) => {
//     setPendingFilters((prev) => ({
//         ...prev,
//         date_filter: time,
//         date_filter_range: null,
//     }));
// };

// const handleDateRangeFilterChange = (time) => {
//     setPendingFilters((prev) => ({
//         ...prev,
//         date_filter: null,
//         date_filter_range: time,
//     }));
// };

// const applyFilters = () => {
//     setCategoryFilters(pendingFilters.category);
//     setDateFilter(pendingFilters.date_filter);
//     setDateRangeFilter(pendingFilters.date_filter_range);
//     setCurrentPage(1);
// };

const isYearActive = selectedFilters?.year?.length > 0;
const isDateFilterActive = date_filter || (date_filter_range?.start || date_filter_range?.end);
useEffect(() => {
    if (selectedFilters?.year?.length > 0) {
        setDateFilter("");
        setDateRangeFilter(null);
    }
}, [selectedFilters.year]);

useEffect(() => {
    if (date_filter || date_filter_range?.start || date_filter_range?.end) {
        setSelectedFilters(prev => ({
            ...prev,
            year: []
        }));
    }
}, [date_filter, date_filter_range]);
  
    useEffect(() => {

        // if (download !== 1) {
            setLoading(true);
        // }

        const all_params = Object.fromEntries(
            Object.entries({
                page : current_page,
                source: category_filters?.source,
                donor: category_filters?.donors,
                aid_type: category_filters?.aid_type,
                sub_aid_type: category_filters?.sub_aid_type,
                recipient: category_filters?.recipient,
                beneficiary: category_filters?.beneficiary,
                governate: category_filters?.governate,
                year: category_filters?.year,
                date_filter: date_filter || undefined,
                start_date : date_filter != null ? undefined : date_filter_range?.start,
                end_date : date_filter != null ? undefined : date_filter_range?.end,
                export_data : download === 1 ? 1 : 0
            }).filter(([_, value]) => value != null) 
        );

        const { export_data, ...searchParams } = all_params;

        setTrackerDataApiOptions({
            
            url: "tracker-data?page=" + current_page,
            params : all_params,
            callback: (res) => {

                if(res?.data?.donations){
                    setTrackerData(null);
                    setTrackerData(res.data);
                    setLastPage(res.data?.donations?.last_page || 1)
                    setLoading(false)
                }
                else {
                    const link = document.createElement("a");
                    link.href = res.data;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    setTimeout(() => {
                        setLoading(false);
                        setDownload(0);
                    }, 100);
                }
            },
        });

        setSearchParams(searchParams);

    }, [category_filters, date_filter,date_filter_range , current_page, download]);


    const getPaginationRange = () => {
        const totalPage = last_page;
        const currentPage = current_page;
        const pages = [];
      
        let range;
        if (window.innerWidth < 600) {
          range = 2; 
        } else {
          range = 4; 
        }
        
        if (totalPage <= range + 2) {
          for (let i = 1; i <= totalPage; i++) {
            pages.push(i);
          }
        } else {
          pages.push(1);
          
          let left = currentPage - Math.floor(range / 2);
          let right = currentPage + Math.floor(range / 2);
          
          if (left < 2) {
            left = 2;
            right = left + range - 1;
          }
          if (right > totalPage - 1) {
            right = totalPage - 1;
            left = right - range + 1;
          }
          
          if (left > 2) {
            pages.push("...");
          }
          
          for (let i = left; i <= right; i++) {
            pages.push(i);
          }
          
          if (right < totalPage - 1) {
            pages.push("...");
          }
          
          pages.push(totalPage);
        }
        
        return pages;
      };

    const labels = tracker_data?.chart_data?.map(item => item.title);
    const data_values = tracker_data?.chart_data?.map(item => item.total_amount);

    const color_palette = [
        "#FF0000", 
        "#008E1C",   
        "#FF9500", 
        "#1B99D6", 
        "#FFE031", 
        "#213469", 
        "#BF3F3F", 
        "#357A38", 
        "#A0522D", 
        "#AED6F1", 
        "#E5C07B", 
        "#2C3E50", 
        "#8C1E1E", 
        "#006837", 
        "#D2691E", 
        "#4682B4", 
        "#D4B24C", 
        "#7F8C8D", 
        "#A94442", 
        "#5B8C5A",  
        "#F0C674", 
        "#6C5B7B", 
        "#008080",
        "#CD5C5C", 
        "#B39EB5"  
      ];

    const background_colors = labels && labels.length > 0 ? labels.map((label, index) => color_palette[index % color_palette.length]) : [color_palette[5]];

    const chart_data = {
        labels: labels && labels.length > 0 ? labels : [locale === 'en' ? 'No Data' : 'لا توجد بيانات'],
        datasets: [
          {
            label: "",
            data: data_values && data_values.length > 0 ? data_values : [1],
            backgroundColor: background_colors,
          },
        ],
    };
    
      const options = {
        responsive: true,
        maintainAspectRatio: false,
        textDirection: locale === 'en'? 'ltl' : 'rtl',
        plugins: {
            legend: {
                display: true,
                position: "bottom", 
                labels: {
                    usePointStyle: true,
                    padding: 20, 
                    color : "#213469",
                    font: {
                        family : locale === 'en' ? 'Helvetica' : 'Rubik'
                    },
                },
                align: locale === 'en' ? "start" : 'end',
                onHover: function (event) {
                    event.native.target.style.cursor = "pointer";
                },
                onLeave: function (event) {
                    event.native.target.style.cursor = "default";
                }
            },
            title: {
                display: true, 
                text: locale === 'en' ? "Total Items Received" : "إجمالي العناصر المستلمة", 
                font: {
                  size: 20, 
                  family : locale === 'en' ? 'Helvetica' : 'Rubik'
                },
                color : "#213469",
                padding: {
                  bottom: 20
                },
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        const dataset = tooltipItem.dataset;
                        const index = tooltipItem.dataIndex;
                        const value = Number(dataset.data?.[index] || 0); 
                        const total = dataset.data?.reduce((sum, val) => sum + Number(val || 0), 0) || 0;
                        const percentage = total > 0 ? ((value / total) * 100).toFixed(2) : "0.00";
                  
                        return  locale === 'en' ? `${value} items (${percentage}%)` : `${convertToArabicNumbers(value)} سلعة (%${convertToArabicNumbers(percentage)})` ;
                      },
                },
                backgroundColor: "#fff", 
                bodyColor: "#213469", 
                titleColor : "#213469",
                padding: 10,
                borderWidth: 3,
                displayColors: false,
                rtl: locale === 'ar',
                textDirection: locale === 'ar' ? 'rtl' : 'ltr', 
            },
          },
      };


    const disablePrev = current_page === 1;
    const disableNext = current_page === last_page;

    function getSafariVersion() {
        const ua = navigator.userAgent;
        const match = ua.match(/Version\/([\d.]+).*Safari/);
        return match ? parseFloat(match[1]) : null;
      }
      
      const safariVersion = getSafariVersion();
      
      if (safariVersion === null || safariVersion >= 16) {
        const style = document.createElement('style');
        style.innerHTML = `.date-picker-range::placeholder { height: 30px !important; }`;
        document.head.appendChild(style);
      }

    // const [pendingFilters, setPendingFilters] = useState({
    //     category: {},
    //     date_filter: null,
    //     date_filter_range: null,
    // });

    return (
        <>
            <Api options={generalDataApiOptions} />
            <Api options={trackerDataApiOptions} />

            {
                tracker_settings ?
                    <Layout activePage="tracker">
                        <Helmet>
                            <title>{generalDataGlobal[0]?.seo[11].title}</title>
                            <meta name="title" content={generalDataGlobal[0]?.seo[11].title} />
                            <meta name="description" content={generalDataGlobal[0]?.seo[11].description} />

                            <meta property="og:title" content={generalDataGlobal[0]?.seo[11].title} />
                            <meta property="og:description" content={generalDataGlobal[0]?.seo[11].description} />
                            <meta property="og:image" content={generalDataGlobal[0]?.seo[11].image_path} />

                            <meta property="twitter:title" content={generalDataGlobal[0]?.seo[11].title} />
                            <meta property="twitter:description" content={generalDataGlobal[0]?.seo[11].description} />
                            <meta property="twitter:image" content={generalDataGlobal[0]?.seo[11].image_path} />
                        </Helmet>
                        <div className="container">
                            <section className="pt-5 mb-4">
                                
                                <div className="tracker-title d-flex align-items-center mb-3">
                                    <h1 className="mb-0 ps-1">{tracker_settings.title}</h1>
                                </div>

                                <div className="row">
                                    <div className="col-12">
                                        <div className="mb-4 tracker-description" dangerouslySetInnerHTML={{
                                            __html: tracker_settings.description
                                        }}>
                                        </div>
                                    </div>
                                </div>
                                <TrackerFilter 
                                    trackerSettings = {tracker_settings}
                                    selectedFilters={selectedFilters}
                                    onFilterChange={handleFilterChange} 
                                    filters={tracker_data?.filters}
                                    setSelectedFilters={setSelectedFilters} 
                                    disabledYear={isDateFilterActive}
                                />

                                <div className="row mb-4 pb-2">
                                <TrackerTotalItems icon={process.env.REACT_APP_BASE_URL + tracker_settings?.total_amount_image} number={formatNumber(tracker_data?.total_amount_usd, locale)} title={tracker_settings.total_usd}/>
                                <TrackerTotalItems icon={process.env.REACT_APP_BASE_URL + tracker_settings?.total_quantity_image} number={formatNumber(tracker_data?.total_items, locale)} title={tracker_settings.total_amount}/>
                                <TrackerTotalItems icon={process.env.REACT_APP_BASE_URL + tracker_settings?.total_distributed_image} number={formatNumber(tracker_data?.total_distributed, locale)} title={tracker_settings.total_distributed}/>
                                </div>

                                <DateFilter 
                                    selectedDate={selected_date}
                                    startDate={startDate}
                                    endDate={endDate}
                                    onDateFilterChange={handleDateFilterChange} 
                                    onDateRangeChange={handleDateRangeFilterChange}
                                    clearAllFilters={clearAllFilters} 
                                    setSelectedDate={setSelectedDate} 
                                    setStartDate={setStartDate} 
                                    setEndDate={setEndDate} 
                                    trackerSettings={tracker_settings}
                                    hasActiveFilters={has_active_filters}
                                    // applyFilters={applyFilters}
                                    isDisabled={isYearActive}
                                />
                            </section>
                            <section>
                            <div style={{ padding : "20px"}} className="chart-container">
                                <Doughnut data={chart_data} options={options} />
                            </div>
                            </section>
                            <div className="table-container">
                            {tracker_data?.donations?.data?.length > 0 ? (
                            <table className="table custom-table">
                                <thead className="table-head">
                                    <tr>
                                    <th style={{ minWidth: '150px' }}>{tracker_settings?.source_title}</th>
                                    <th className="text-center" style={{ minWidth: '250px' }}>{tracker_settings?.donor_title}</th>
                                    <th style={{ minWidth: '150px' }}>{tracker_settings?.aid_type_title}</th>
                                    <th style={{ minWidth: '150px' }}>{tracker_settings?.sub_aid_title}</th>
                                    <th style={{ minWidth: '170px' }}>{tracker_settings?.sub_aid_explanation_title}</th>
                                    <th style={{ minWidth: '150px' }}>{tracker_settings?.amount_title}</th>
                                    <th style={{ minWidth: '150px' }}>{tracker_settings?.unit_title}</th>
                                    <th style={{ minWidth: '170px' }}>{tracker_settings?.amount_usd_title}</th>
                                    <th style={{ minWidth: '150px' }}>{tracker_settings?.amount_tons_title}</th>
                                    <th style={{ minWidth: '170px' }}>{tracker_settings?.recipient_title}</th>
                                    <th style={{ minWidth: '170px' }}>{tracker_settings?.beneficiary_title}</th>
                                    <th style={{ minWidth: '150px' }}>{tracker_settings?.governate_title}</th>
                                    <th style={{ minWidth: '150px' }}>{tracker_settings?.delivery_date_title}</th>
                                    <th style={{ minWidth: '150px' }}>{tracker_settings?.notes_title}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    
                                        {tracker_data.donations.data.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.source?.title || '-'}</td>
                                            <td>{item.donor_list?.title || '-'}</td>
                                            <td>{item.aid_type?.title || '-'}</td>
                                            <td>{item.sub_aid_type?.title || '-'}</td>
                                            <td>{item.sub_aid_explanation || '-'}</td>
                                            <td>{item.amount || '-'}</td>
                                            <td>{item.unit_of_measurment?.title || '-'}</td>
                                            <td>{item.amount_in_usd || '-'}</td>
                                            <td>{item.amount_in_tons || '-'}</td>
                                            <td>{item.recipient?.title || '-'}</td>
                                            <td>{item.beneficiary?.title || '-'}</td>
                                            <td>{item.governate?.title || '-'}</td>
                                            <td>{item.delivery_date || '-'}</td>
                                            <td>{item.notes || '-'}</td>
                                        </tr>
                                        ))}
                                </tbody>
                            </table> ) : (
                                    <p className="no-data-message d-flex justify-content-center my-5 pt-5">
                                        {locale === "en" ? "No Data Available" : "لا توجد بيانات"}
                                    </p>
                                )}
                            </div>
                            <div className="d-lg-flex">
                                {tracker_data?.donations?.data?.length ? (
                                <div className="pagination-container mb-4 flex-grow-1 d-flex justify-content-center ms-lg-5 ps-lg-5 pb-3 pb-lg-0" animate="right">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="pagination-content d-flex">
                                                <div
                                                    className={
                                                        "me-2 tracker-arrow " + (locale === "en" ? "prev-arrow" : "next-arrow") + (disablePrev ? " low-opacity" : "")
                                                    }
                                                    onClick={
                                                        !disablePrev ? () => setCurrentPage(current_page - 1) : undefined
                                                    }
                                                >
                                                    <a href="#" onClick={(e) => e.preventDefault()}>
                                                        <img src="/assets/images/next-arrow.svg" alt="Previous" />
                                                    </a>
                                                </div>

                                                <div className="pages d-flex">
                                                    {getPaginationRange().map((page, index, arr) => (
                                                        <div
                                                            key={index}
                                                            className={
                                                            "page-div tracker-page-div d-flex justify-content-center align-items-center me-2 " +
                                                            (page === current_page  && page !== '...' ? " active-page" : "")
                                                            }
                                                            onClick={() => {
                                                            if (page === "...") {
                                                                if (index === 1) {
                                                                setCurrentPage(Math.max(current_page - 5, 1));
                                                                } 
                                                                else if (index === arr.length - 2) {
                                                                setCurrentPage(Math.min(current_page + 5, last_page));
                                                                }
                                                            } else {
                                                                setCurrentPage(page);
                                                            }
                                                            }}
                                                        >
                                                            <a href="#" onClick={(e) => e.preventDefault()}>
                                                            <p>
                                                                {typeof page === "number"
                                                                ? page.toLocaleString(locale === "ar" ? "ar-EG" : "en-US")
                                                                : page}
                                                            </p>
                                                            </a>
                                                        </div>
                                                        ))}
                                                </div>

                                                <div
                                                    className={'tracker-arrow ' + (locale === "en" ? "next-arrow" : "prev-arrow") + (disableNext ? " low-opacity" : "")}
                                                    onClick={
                                                        !disableNext ? () => setCurrentPage(current_page + 1) : undefined
                                                    }
                                                >
                                                    <a href="#" onClick={(e) => e.preventDefault()}>
                                                        <img src="/assets/images/next-arrow.svg" alt="Next" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        <button onClick={() => setDownload(1)} disabled={!tracker_data?.donations?.data?.length} className="download-button d-flex align-items-center justify-content-center ms-auto mt-5 mt-lg-0 ">
                            <p className="mb-0">{tracker_settings?.download}</p>
                            <img src="/assets/images/download-white.svg" width="16px" height="16px" className="ms-3" alt="Download Excel"/>
                        </button>
                        </div>
                        </div>
                    </Layout>
                    : null
                    }
            {loading ? 
                    <div className="overlay">
                        <div className="custom-loader"></div>
                    </div> 
                : null}
                 
        </>
    )

}